import React from 'react';

const BackendNotConfigured = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-purple-900 to-slate-900 flex items-center justify-center p-4">
      <div className="max-w-2xl w-full bg-white/10 backdrop-blur-lg rounded-2xl shadow-2xl p-8 border border-white/20">
        <div className="text-center">
          {/* Icon */}
          <div className="mb-6">
            <svg
              className="mx-auto h-16 w-16 text-yellow-400"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
              />
            </svg>
          </div>

          {/* Title */}
          <h1 className="text-3xl font-bold text-white mb-4">
            Backend Not Configured
          </h1>

          {/* Description */}
          <p className="text-gray-300 mb-6 text-lg">
            The Code Wizard backend API is not configured for this deployment.
          </p>

          {/* Instructions */}
          <div className="bg-black/30 rounded-lg p-6 text-left mb-6">
            <h2 className="text-xl font-semibold text-white mb-4">
              To fix this:
            </h2>
            <ol className="space-y-3 text-gray-300">
              <li className="flex items-start">
                <span className="flex-shrink-0 w-6 h-6 rounded-full bg-purple-500 text-white flex items-center justify-center text-sm mr-3 mt-0.5">
                  1
                </span>
                <span>
                  Deploy the backend to Railway or another hosting service
                </span>
              </li>
              <li className="flex items-start">
                <span className="flex-shrink-0 w-6 h-6 rounded-full bg-purple-500 text-white flex items-center justify-center text-sm mr-3 mt-0.5">
                  2
                </span>
                <span>
                  Add <code className="bg-black/40 px-2 py-1 rounded text-yellow-300">REACT_APP_BACKEND_URL</code> to your Vercel environment variables
                </span>
              </li>
              <li className="flex items-start">
                <span className="flex-shrink-0 w-6 h-6 rounded-full bg-purple-500 text-white flex items-center justify-center text-sm mr-3 mt-0.5">
                  3
                </span>
                <span>
                  Redeploy your Vercel project
                </span>
              </li>
            </ol>
          </div>

          {/* Documentation Link */}
          <div className="space-y-3">
            <a
              href="https://github.com/patriotnewsactivism/replitalt/blob/main/DEPLOYMENT.md"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block bg-purple-600 hover:bg-purple-700 text-white font-semibold px-6 py-3 rounded-lg transition-colors duration-200"
            >
              View Deployment Guide
            </a>

            <p className="text-gray-400 text-sm">
              For local development, see{' '}
              <code className="bg-black/40 px-2 py-1 rounded text-yellow-300">
                DEPLOYMENT.md
              </code>
            </p>
          </div>

          {/* Environment Info */}
          <div className="mt-8 pt-6 border-t border-white/10">
            <p className="text-gray-400 text-sm">
              <strong>Current Environment:</strong> {process.env.NODE_ENV || 'development'}
            </p>
            <p className="text-gray-400 text-sm mt-1">
              <strong>Backend URL:</strong>{' '}
              <code className="text-yellow-300">
                {process.env.REACT_APP_BACKEND_URL || 'Not set'}
              </code>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BackendNotConfigured;
